export default "__VITE_ASSET__DmnSFjRp__"